import React from "react";
import { Facebook, Instagram } from "react-feather";
import { Row, Col } from "reactstrap";
import "./footer.css";
import { Link } from "react-router-dom";
function Footer() {
  const aboutItems = [
    { text: "Our Values", link: "/pages/our-values" },
    { text: "Privacy Policy", link: "/pages/privacy-policy" },
    { text: "Terms & Conditions", link: "/pages/terms" },
    { text: "Discalimer", link: "/pages/disclaimer" },
    { text: "Corporate information", link: "/pages/corporate-information" },
  ];
  const helpItems = [
    { text: "FAQs", link: "/pages/faqs" },
    { text: "Return & refund policy", link: "/pages/return-refund-policy" },
    { text: "ContactUs", link: "/pages/get-in-touch" },
  ];
  return (
    <>
      <Row className="main_footer">
        <Col className="footer_inner">
          <Row>
            <Col md={2}>
              <b className="footer_heading">About</b>
              <ul className="footer_ul">
                {aboutItems?.map((item, index) => (
                  <li
                    key={item?.text}
                    className="footer_li"
                    onClick={() => {
                      window.open(item.link, "_self");
                    }}
                  >
                    {item?.text}
                  </li>
                ))}
              </ul>
            </Col>
            <Col md={2}>
              <b className="footer_heading">Help</b>
              <ul className="footer_ul">
                {helpItems?.map((item, index) => (
                  <li
                    key={item?.text}
                    className="footer_li"
                    onClick={() => {
                      window.open(item.link, "_self");
                    }}
                  >
                    {item?.text}
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
          <hr className="footer_hr" />
          <Row className="footer_bottom_social">
            <Instagram
              onClick={() =>
                window.open("https://www.instagram.com/aquibyazdani/")
              }
              className="footer_bottom_social_icon"
            />
            <Facebook
              onClick={() =>
                window.open("https://www.facebook.com/aquibyazdani")
              }
              className="footer_bottom_social_icon"
            />
          </Row>
          <Row>
            <Col className="footer_credits">
              <p>Copyright @{new Date().getFullYear()}, Shoppe</p>
              <p>Powered by Aquib Yazdani</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default Footer;
